module.exports = __webpack_public_path__ + "img/building.9a30e2ca.svg";